import { create } from "zustand";

/**
 * Freezes the header's cart badge while the PDP add-to-cart flight plays, so the
 * count only ticks up once the icon has landed on the cart — the shopper sees one
 * story rather than the number jumping before the animation explains why.
 *
 * It holds a flag rather than a number: the badge's count is derived in `useHeader`
 * (in-stock lines only), and copying that rule into the product page would leave two
 * places to keep in step. The header keeps showing its last value while held.
 *
 * The flight owns both calls and releases on unmount, so a page left mid-flight
 * cannot strand the badge.
 */
interface CartBadgeHoldState {
    isHeld: boolean;
    hold: () => void;
    release: () => void;
}

export const useCartBadgeHoldStore = create<CartBadgeHoldState>((set) => ({
    isHeld: false,
    hold: () => set({ isHeld: true }),
    release: () => set({ isHeld: false }),
}));
